export function Brand({ variant = "navigation" }: { variant?: "navigation" | "login" }) {
  if (variant === "login") {
    return <img src="/gunbound-logo.png" alt="Gunbound World Champion" width={1254} height={1254} className="mx-auto size-48 object-contain" fetchPriority="high" />;
  }
  return (
    <span className="flex min-w-0 items-center gap-3">
      <img src="/gunbound-logo.png" alt="Gunbound World Champion" width={1254} height={1254} className="size-24 shrink-0 object-contain" />
      <span className="border-l pl-3 text-xs font-medium text-muted-foreground">Admin</span>
    </span>
  );
}
